export interface PivotGridEntityFieldProvider {
    [key: string]: {
        defaultConfig: string;
        availableConfigs: Array<{
            name: string;
            displayName: string;
            fields: any[];
        }>;
    };
}

export default {
    'cdrDettaglio': {
        defaultConfig: 'ricavo_vs_costo',
        availableConfigs: [
            {
                name: 'ricavo_vs_costo',
                displayName: 'Ricavo Totale per fornitore / Costo totale per fornitore',
                fields: [
                    {
                        dataField: 'anno',
                        caption: 'Anno',
                        area: 'column',
                        dataType: 'number'
                    },
                    {
                        dataField: 'mese',
                        caption: 'Mese',
                        area: 'column',
                        dataType: 'number'
                    },
                    {
                        dataField: 'costo_totale',
                        caption: 'Costo Totale',
                        area: 'data',
                        summaryType: 'sum',
                        format: { type: 'fixedPoint', precision: 8 }
                    },
                    {
                        dataField: 'ricavo_totale',
                        caption: 'Ricavo Totale',
                        area: 'data',
                        summaryType: 'sum',
                        format: { type: 'fixedPoint', precision: 8 }
                    },
                    {
                        dataField: 'chiamate_totali',
                        caption: 'Chiamate Totali',
                        area: 'data',
                        summaryType: 'sum',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_totali',
                        caption: 'minuti Totali',
                        area: 'data',
                        summaryType: 'sum',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_vs_mobile',
                        caption: 'minuti vs mobili',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_vs_fisso',
                        caption: 'minuti vs fissi',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_vs_altri',
                        caption: 'minuti vs altri',
                        dataType: 'number'
                    },
                    {
                        dataField: 'V_Fornitore',
                        caption: 'Fornitore',
                        area: 'row',
                        dataType: 'string'
                    },
                    {
                        dataField: 'V_Listino',
                        caption: 'Listino',
                        area: 'column',
                        dataType: 'string'
                    },
                    {
                        dataField: 'V_CodiceUtenza',
                        caption: 'Codice Utenza',
                        dataType: 'string'
                    },
                    {
                        dataField: 'V_NomeUtenza',
                        caption: 'Nome Utenza',
                        area: 'row',
                        dataType: 'string'
                    }
                ]
            },
            {
                name: 'report_controllo_utenze',
                displayName: 'Report di controllo per utenza',
                fields: [
                    {
                        dataField: 'anno',
                        caption: 'Anno',
                        area: 'column',
                        dataType: 'number',
                        expanded: true
                    },
                    {
                        dataField: 'mese',
                        caption: 'Mese',
                        area: 'column',
                        dataType: 'number',
                        expanded: true
                    },
                    {
                        dataField: 'V_Listino',
                        caption: 'Listino',
                        area: 'column',
                        dataType: 'string',
                        expanded: true
                    },
                    {
                        dataField: 'V_CodiceUtenza',
                        caption: 'Codice Utenza',
                        area: 'row',
                        dataType: 'string',
                        expanded: true
                    },
                    {
                        dataField: 'chiamate_totali',
                        caption: 'Chiamate Totali',
                        dataType: 'number',
                        area: 'data',
                        summaryType: 'sum'
                    },
                    {
                        dataField: 'minuti_totali',
                        caption: 'minuti Totali',
                        dataType: 'number',
                        area: 'data',
                        summaryType: 'sum'
                    },
                    {
                        dataField: 'minuti_vs_mobile',
                        caption: 'minuti vs mobili',
                        dataType: 'number',
                        area: 'data',
                        summaryType: 'sum'
                    },
                    {
                        dataField: 'minuti_vs_fisso',
                        caption: 'minuti vs fissi',
                        dataType: 'number',
                        area: 'data',
                        summaryType: 'sum'
                    },
                    {
                        dataField: 'minuti_vs_altri',
                        caption: 'minuti vs altri',
                        dataType: 'number',
                        area: 'data',
                        summaryType: 'sum'
                    }
                ]
            },
            {
                name: 'top_20_clienti',
                displayName: 'migliori clienti per periodo',
                fields: [
                    {
                        dataField: 'anno',
                        caption: 'Anno',
                        area: 'column',
                        dataType: 'number'
                    },
                    {
                        dataField: 'mese',
                        caption: 'Mese',
                        area: 'column',
                        dataType: 'number'
                    },
                    {
                        dataField: 'costo_totale',
                        caption: 'Costo Totale',
                        area: 'data',
                        summaryType: 'sum',
                        format: { type: 'fixedPoint', precision: 8 }
                    },
                    {
                        dataField: 'ricavo_totale',
                        caption: 'Ricavo Totale',
                        area: 'data',
                        summaryType: 'sum',
                        format: { type: 'fixedPoint', precision: 8 }
                    },
                    {
                        dataField: 'chiamate_totali',
                        caption: 'Chiamate Totali',
                        area: 'data',
                        summaryType: 'sum',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_totali',
                        caption: 'minuti Totali',
                        area: 'data',
                        summaryType: 'sum',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_vs_mobile',
                        caption: 'minuti vs mobili',
                        summaryType: 'sum',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_vs_fisso',
                        caption: 'minuti vs fissi',
                        summaryType: 'sum',
                        dataType: 'number'
                    },
                    {
                        dataField: 'minuti_vs_altri',
                        caption: 'minuti vs altri',
                        summaryType: 'sum',
                        dataType: 'number'
                    },
                    {
                        dataField: 'V_Fornitore',
                        caption: 'Fornitore',
                        dataType: 'string'
                    },
                    {
                        dataField: 'V_Listino',
                        caption: 'Listino',
                        dataType: 'string'
                    },
                    {
                        dataField: 'V_CodiceUtenza',
                        caption: 'Codice Utenza',
                        dataType: 'string'
                    },
                    {
                        dataField: 'V_NomeUtenza',
                        caption: 'Nome Utenza',
                        area: 'row',
                        dataType: 'string',
                        sortBySummaryField: 'ricavo_totale',
                        sortOrder: 'desc',
                    }
                ]
            }
        ]
    }
} as PivotGridEntityFieldProvider;